import { render, staticRenderFns } from "./modellist.vue?vue&type=template&id=6b37395c&scoped=true"
import script from "./modellist.vue?vue&type=script&lang=js"
export * from "./modellist.vue?vue&type=script&lang=js"
import style0 from "./modellist.vue?vue&type=style&index=0&id=6b37395c&prod&lang=scss"
import style1 from "./modellist.vue?vue&type=style&index=1&id=6b37395c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b37395c",
  null
  
)

export default component.exports